import React, { useState } from "react";
import PropTypes from "prop-types";

const propTypes = {
  defaultHidden: PropTypes.object,
};

const defaultProps = {
  defaultHidden: {},
};

export const WrapperHiddenParameters = ({ defaultHidden, children }) => {
  const [resize, setResize] = useState([]);
  const [hidden, setHidden] = useState(defaultHidden || []);

  const onResize = (col, index) => (e, { size }) => {
    const nextResize = [...resize];
    nextResize[col] = size.width;
    setResize(nextResize);
  };

  const onToggleVisible = (col) => {
    const nextHidden = { ...hidden };
    const value = nextHidden[col] ? nextHidden[col] : 0;
    nextHidden[col] = value == 0 ? 1 : 0;
    setHidden(nextHidden);
  };

  return (
    <React.Fragment>
      {children({
        hidden,
        resize,
        onResize,
        onToggleVisible,
      })}
    </React.Fragment>
  );
};

WrapperHiddenParameters.propTypes = propTypes;
WrapperHiddenParameters.defaultProps = defaultProps;

export default WrapperHiddenParameters;
